import { c as _c } from "react/compiler-runtime";
import { MenuItem, Select, type SelectChangeEvent } from "@mui/material";
import Image from "next/image";
import type { ProgrammingLanguage } from "#/features/codeRunner/hooks/useCodeExecution";
import javaScriptLogo from "#/features/codeRunner/ui/assets/javaScriptLogo.svg";
import pythonLogo from "#/features/codeRunner/ui/assets/pythonLogo.svg";
export type EditorLanguageSelectProps = {
  language: ProgrammingLanguage | "";
  handleLanguageChange: (event: SelectChangeEvent<ProgrammingLanguage>) => void;
};
export const EditorLanguageSelect: React.FC<EditorLanguageSelectProps> = t0 => {
  const $ = _c(7);
  const {
    language,
    handleLanguageChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginRight: "-6px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: 32,
      width: 48,
      overflow: "hidden",
      fontSize: "8px",
      "& [data-testid=ArrowDropDownIcon]": t1,
      "& [role=combobox]": {
        padding: "8px",
        color: "transparent",
        "& > svg": {
          color: "text.primary"
        }
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MenuItem value="javascript"><Image src={javaScriptLogo} alt="JavaScript Logo" width={16} height={16} />  JavaScript</MenuItem>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MenuItem value="python"><Image src={pythonLogo} alt="Python Logo" width={16} height={16} />  Python</MenuItem>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== handleLanguageChange || $[5] !== language) {
    t5 = <Select size="small" value={language} onChange={handleLanguageChange} sx={t2}>{t3}{t4}</Select>;
    $[4] = handleLanguageChange;
    $[5] = language;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};